$(document).ready(function() {
  const $form = $('.action-page-form');

  $form.find('[data-form-error]').hide();
  $('[data-form-state]').hide();

  $('[data-action-button]').on('click', function(e) {
    $('[data-action-form]').toggleClass('_active');
    $('[data-form-state]').hide();
  });

  const observer = new MutationObserver((targets) => {
    targets.forEach((entry) => {
      if (entry.attributeName === 'class') {
        $form.find(`[data-form-error="${entry.target.name}"]`).each((_, el) => {
          $(el).toggle(entry.target.classList.contains('error'))
        })
      }
    })
  });

  $form.find('input').each((idx, el) => {
    observer.observe(el, {
      childList: false,
      subtree: false,
      attributes: true,
      attributeFilter: ['class'],
      characterData: false
    });
  });

  new InteractiveForm($form, {
    submitHandler: (form) => {
      let dataToSend = $.extend(true, $form.serializeObject(), {
        Submit: 1,
        url: window.location.href,
      });
      $.ajax({
        url: form.action,
        type: form.method,
        data: dataToSend
      }).done((response) => {
        if (!response.code) {
          $('[data-form-state="success"]').show();
        } else {
          $('[data-form-state="error"]').show();
        }
        $('[data-action-form]').toggleClass('_active');
        $form.trigger('reset');
        $form.find('.input').removeClass('_focus');
      });
    },
    validatorParams: {
      rules: {
        name: {
          required: true,
          regex: /[^ ]{3,}/
        }
      }
    }
  });
});
